import styles from './VisuallyHidden.module.css';

type VisuallyHiddenProps = {
  children: React.ReactNode;
  /** When set, renders as the given element (default `span`). */
  as?: 'span' | 'div' | 'p' | 'h1' | 'h2' | 'h3';
};

export function VisuallyHidden({ children, as: Tag = 'span' }: VisuallyHiddenProps) {
  return <Tag className={styles.root}>{children}</Tag>;
}
